import React, { Component } from 'react'
import { connect } from 'react-redux'

import { TicketWizard as TicketWizard23 } from 'projects/flow-gui-access/views/2.3/ticket'
import { TicketWizard as TicketWizard24 } from 'projects/flow-gui-access/views/2.4/ticket'

class TicketWizard extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'tickets' && endpoint.version === '2.4').length !== 0) {
      return <TicketWizard24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'tickets' && endpoint.version === '2.3').length !== 0) {
      return <TicketWizard23 {...this.props} />
    } else return false
  }
}
//eslint-disable-next-line
TicketWizard = connect(state => state)(TicketWizard)
export default TicketWizard



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/ticket/wizard.js